import React from 'react'
import '../stylesheets/Success.css';
import {BrowserView, MobileView} from 'react-device-detect';

export const Success = () => {
  return (
     <div className= "body">
            <BrowserView>
              <h2 className="subhead" id="first">Success!</h2>
              <p className='paragraph'>Thank you for reaching out! We will contact you shortly.</p>
            </BrowserView>
            <MobileView>
              <h2 className="mobileSubhead" id="first">Success!</h2>
              <p className='mobileParagraph'>Thank you for reaching out! We will contact you shortly.</p>
            </MobileView>
      </div>
  )
}
